var moduleMap = {
	"./MyCoursesPage": () => {
		return Promise.all([__webpack_require__.e(430), __webpack_require__.e(920), __webpack_require__.e(845), __webpack_require__.e(610), __webpack_require__.e(914), __webpack_require__.e(985), __webpack_require__.e(646), __webpack_require__.e(204), __webpack_require__.e(427), __webpack_require__.e(993)]).then(() => (() => ((__webpack_require__(29993)))));
	},
	"./TeacherCoursesPage": () => {
		return Promise.all([__webpack_require__.e(430), __webpack_require__.e(920), __webpack_require__.e(845), __webpack_require__.e(610), __webpack_require__.e(914), __webpack_require__.e(985), __webpack_require__.e(646), __webpack_require__.e(204), __webpack_require__.e(427), __webpack_require__.e(776)]).then(() => (() => ((__webpack_require__(92776)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});